const mutations = {
    MEMBERSHIP_LOADING: state => {
        state.membershipStatus = "loading";
    },
    MEMBERSHIP_SUCCESS: (state, membership) => {
        state.membershipStatus = "success";
        Vue.set(state, "membershipCart", membership.data);
    },
    MEMBERSHIP_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.membershipStatus = "error";
        state.membershipErrors.record(errors);
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
